import React from "react";
import {styled} from '@mui/material/styles';
import {Header} from "components/Header/Header";
import {Sidebar} from "components/Sidebar/Sidebar";

const drawerWidth = 220;
const barHeight = 50;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: `${barHeight}px`,
    marginLeft: 0,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${drawerWidth}px`,
    }),
  }),
);

export const MainLayout = (props) => {
  const {
    drawerWidth = 220,
    barHeight = 50,
    children
  } = props;
  const [state, setState] = React.useState({open: false});

  const handleDrawerOpen = () => {
    setState({ open: !state.open });
  };

  return (
    <>
      <Header
        barHeight={barHeight}
        handleDrawerOpen={handleDrawerOpen}
      />
      <Sidebar
        drawerWidth={drawerWidth}
        open={state.open}
        handleDrawerOpen={handleDrawerOpen}
      />
      <Main
        open={state.open}
        sx={{
          marginLeft: { xs: 0, sm: `${state.open? drawerWidth: 0}px`},
          backgroundColor: '#f5f6f7',
          height: `calc(100vh - ${barHeight}px)`,
          overflow: 'auto',
          padding: '15px 0 0 15px',
        }}
      >
        {children}
      </Main>
    </>
  );
};
